export const vocale = ["a", "e", "i", "o", "u", "ä", "ö", "ü"]
